import * as React from "react";
import { Col } from "./../Col";
import * as CMP from "../../../../components";

export class Fixture extends React.Component<{ top: string, bottom: string }, {}> {
    render() {
        return (
            <Col modifier="rj-racing-next-races__col--name">
                <CMP.Fixture top={this.props.top} bottom={this.props.bottom} />
            </Col>
        )
    }
}